export const brandConfigObjectMap = new Map();

export const Brands = {
    BattleLeaugeGaming: 'blg-en',
    BattleLeaugeGamingMFilter: 'blg-en-mfilter',
    FantasySoccer: 'fantasy-soccer-en',
    FantasySoccerMFilter: 'fantasy-soccer-en-mfilter',
    RushGames: 'rush-games-en',
    RushGamesMFilter: 'rush-games-en-mfilter',
    GameAppWorldMFilter: 'gameapp-world-en',
    GameRushMFilter: 'game-rush-mfilter'
}

export const SourceGroups = Object.freeze({
    Penrose: 'penrose',
    Rgs: 'rgs',
});

brandConfigObjectMap.set(Brands.BattleLeaugeGamingMFilter, {
    assetBrand: 'blg-en-mfilter',
    flowType: 'mfilter',
    sourceGroup: SourceGroups.Penrose,
    serviceFamily: 'blg',
    pricePoint: 'Battle_League_Gaming',
    offerCode: '001050038683',
    mFilterOfferCode: '1771414341279',
    mfilterRedirectUrl: 'https://ke-mplay.blg.gg',
    gameUrl: 'https://ke-mplay.blg.gg/thank-you',
    errorUrl: 'https://ke-mplay.blg.gg/error',
    platformUrl: 'https://ke.blg.gg',
    headerText: 'Play competitive gaming anytime, anywhere and climb the ranks!',
    subHeaderText: 'Subscribe to Battle League Gaming for 20KSH/day on your Safaricom Account. T&Cs Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-N26B5B4J',
    tabTitle: 'Battle League Gaming',
    productId: 318,
    termsAndConditionsUrl: 'https://ke.blg.gg/terms-conditions'
});

brandConfigObjectMap.set(Brands.BattleLeaugeGaming, {
    assetBrand: 'blg-en',
    flowType: 'evina',
    sourceGroup: SourceGroups.Penrose,
    serviceFamily: 'blg',
    pricePoint: 'Battle_League_Gaming',
    offerCode: '001050038359',
    gameUrl: 'https://ke-play.blg.gg/thank-you',
    errorUrl: 'https://ke-play.blg.gg/error',
    platformUrl: 'https://ke.blg.gg',
    headerText: 'Play competitive gaming anytime, anywhere and climb the ranks!',
    subHeaderText: 'Subscribe to Battle League Gaming for 20KSH/day on your Safaricom Account. T&Cs Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-N26B5B4J',
    tabTitle: 'Battle League Gaming',
    productId: 42,
    termsAndConditionsUrl: 'https://ke.blg.gg/terms-conditions'
});

brandConfigObjectMap.set(Brands.FantasySoccer, {
    assetBrand: 'fantasy-soccer-en',
    flowType: 'evina',
    sourceGroup: SourceGroups.Penrose,
    serviceFamily: 'fantasy',
    pricePoint: 'Fantasy_Sports',
    offerCode: '001050038360',
    gameUrl: 'https://ke-play.fantasyfootball.one/thank-you',
    errorUrl: 'https://ke-play.blg.gg',
    platformUrl: 'https://ke.fantasyfootball.one',
    headerText: 'Compete in top fantasy leagues, rise the ranks & claim glory!',
    subHeaderText: 'Subscribe to Fantasy Sports for 15KSH/day on your Safaricom Account. T&Cs Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-PQ82DJK5',
    tabTitle: 'Fantasy Sports',
    productId: 40,
    termsAndConditionsUrl: 'https://ke.fantasyfootball.one/terms-and-conditions'
});

brandConfigObjectMap.set(Brands.FantasySoccerMFilter, {
    assetBrand: 'fantasy-soccer-en',
    flowType: 'mfilter',
    sourceGroup: SourceGroups.Penrose,
    serviceFamily: 'fantasy',
    pricePoint: 'Fantasy_Sports',
    offerCode: '001050038707',
    mFilterOfferCode: '1775218274245',
    mfilterRedirectUrl: 'https://ke-mplay.fantasyfootball.one',
    gameUrl: 'https://ke-mplay.fantasyfootball.one/thank-you',
    errorUrl: 'https://ke-mplay.fantasyfootball.one/error',
    platformUrl: 'https://ke.fantasyfootball.one',
    headerText: 'Compete in top fantasy leagues, rise the ranks & claim glory!',
    subHeaderText: 'Subscribe to Fantasy Sports for 15KSH/day on your Safaricom Account. T&Cs Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-PQ82DJK5',
    tabTitle: 'Fantasy Sports',
    productId: 320,
    termsAndConditionsUrl: 'https://ke.fantasyfootball.one/terms-and-conditions'
});

brandConfigObjectMap.set(Brands.RushGames, {
    assetBrand: 'rush-games-en',
    flowType: 'evina',
    sourceGroup: SourceGroups.Penrose,
    serviceFamily: 'rush-games',
    pricePoint: 'Rush_Games',
    offerCode: '001050038358',
    gameUrl: 'https://ke-play.yellowrush.co.za/thank-you',
    errorUrl: 'https://ke-play.fantasyfootball.one',
    platformUrl: 'https://ke.yellowrush.co.za',
    headerText: 'The ultimate gaming experience, Enjoy ad-free games today!',
    subHeaderText: 'Subscribe to Rush Games for 20KSH/day on your Safaricom Account. T&Cs Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-WJ2N6HXS',
    tabTitle: 'Rush Games',
    productId: 43,
    termsAndConditionsUrl: 'https://ke.yellowrush.co.za/terms-conditions'
});

brandConfigObjectMap.set(Brands.RushGamesMFilter, {
    assetBrand: 'rush-games-en',
    flowType: 'mfilter',
    sourceGroup: SourceGroups.Penrose,
    serviceFamily: 'rush-games',
    pricePoint: 'Rush_Games',
    offerCode: '001050038706',
    mFilterOfferCode: '1775218399877',
    mfilterRedirectUrl: 'https://ke-mplay.yellowrush.co.za',
    gameUrl: 'https://ke-mplay.yellowrush.co.za/thank-you',
    errorUrl: 'https://ke-mplay.yellowrush.co.za/error',
    platformUrl: 'https://ke.yellowrush.co.za',
    headerText: 'The ultimate gaming experience, Enjoy ad-free games today!',
    subHeaderText: 'Subscribe to Rush Games for 20KSH/day on your Safaricom Account. T&Cs Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-WJ2N6HXS',
    tabTitle: 'Rush Games',
    productId: 319,
    termsAndConditionsUrl: 'https://ke.yellowrush.co.za/terms-conditions'
});

brandConfigObjectMap.set(Brands.GameRushMFilter, {
    assetBrand: 'game-rush-mfilter',
    flowType: 'mfilter',
    sourceGroup: SourceGroups.Rgs,
    serviceFamily: 'game-rush',
    pricePoint: 'Game_Rush',
    offerCode: '001050038720',
    mFilterOfferCode: '1773911963520',
    mfilterRedirectUrl: 'https://rgs-gr-wr.goodgamingco.com',
    gameUrl: 'https://rgs-gr-wr.goodgamingco.com/thank-you',
    errorUrl: 'https://rgs-gr-wr.goodgamingco.com/error',
    platformUrl: 'https://sfc_ke.gamerush.zone',
    headerText: 'Discover Your Game. Own the Rush.',
    subHeaderText: 'Subscribe to Game Rush for 15KSH/day on your Safaricom Account. T&C’s Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-KH4Z27P9',
    tabTitle: 'Game Rush',
    productId: 324,
    termsAndConditionsUrl: '/terms-and-conditions',
    crossSellBannerUrl: 'https://rgs-gr-wr.goodgamingco.com/gr-banner.png',
    backgroundColor: '#550000',
    buttonColor: '#D35E2D',
});

brandConfigObjectMap.set(Brands.GameAppWorldMFilter, {
    assetBrand: 'gameapp-world-en',
    flowType: 'mfilter',
    sourceGroup: SourceGroups.Rgs,
    serviceFamily: 'gameapp-world',
    pricePoint: 'GameApp_World',
    offerCode: '001050038670',
    mFilterOfferCode: '1771585616843',
    mfilterRedirectUrl: 'https://rgs-gaw-wr.goodgamingco.com',
    gameUrl: 'https://rgs-gaw-wr.goodgamingco.com/thank-you',
    errorUrl: 'https://rgs-gaw-wr.goodgamingco.com/error',
    platformUrl: 'https://sfc_ke.gameappworld.zone',
    headerText: 'The Ultimate Gaming Universe Starts Here.',
    subHeaderText: 'Subscribe to GameApp World for 20KSH/day on your Safaricom Account. T&Cs Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-KHHZ5GN8',
    tabTitle: 'GameApp World',
    productId: 322,
    termsAndConditionsUrl: '/terms-and-conditions',
    crossSellBannerUrl: 'https://rgs-gaw-wr.goodgamingco.com/gaw-banner.png',
    backgroundColor: '#1D6A85',
    buttonTextColor: '#000000',
    buttonColor: '#FDFFB6',
});

